import { ZOOM_MAX, ZOOM_MIN, ZOOM_PASSO } from '@core/tabuleiro/camera';

/**
 * Controles `−` / `+` no canto inferior direito (§7.2, §14).
 * O zoom fica limitado entre 50% e 200% (T07-03) e os botões desabilitam nos
 * extremos, para que o limite seja perceptível sem depender de tentativa.
 */
export function ControlesZoom({
  zoom,
  aoAjustar,
}: {
  zoom: number;
  aoAjustar: (delta: number) => void;
}) {
  const porcentagem = Math.round(zoom * 100);

  return (
    <div className="zoom" role="group" aria-label="Zoom do tabuleiro">
      <button
        type="button"
        className="zoom__botao"
        onClick={() => aoAjustar(-ZOOM_PASSO)}
        disabled={zoom <= ZOOM_MIN + 0.001}
        aria-label="Diminuir zoom"
      >
        −
      </button>
      <span className="zoom__valor" aria-live="off">
        {porcentagem}%
      </span>
      <button
        type="button"
        className="zoom__botao"
        onClick={() => aoAjustar(ZOOM_PASSO)}
        disabled={zoom >= ZOOM_MAX - 0.001}
        aria-label="Aumentar zoom"
      >
        +
      </button>
    </div>
  );
}
